import src from "IMAGE";
export default { src, width: 2125, height: 683, blurWidth: 0, blurHeight: 0};
